import { useEffect } from 'react';

interface PublicLayoutProps {
  children: React.ReactNode;
  primaryColor?: string;
}

/**
 * Clean layout for public career pages — no authenticated navbar/sidebar.
 * Applies org primaryColor as CSS variable for branding.
 */
export function PublicLayout({ children, primaryColor }: PublicLayoutProps) {
  useEffect(() => {
    if (primaryColor) {
      document.documentElement.style.setProperty('--career-primary', primaryColor);
    }
    return () => {
      document.documentElement.style.removeProperty('--career-primary');
    };
  }, [primaryColor]);

  return (
    <div className="min-h-screen flex flex-col bg-white">
      <main className="flex-1">{children}</main>
      <footer className="border-t bg-gray-50/80 mt-auto">
        <div className="container mx-auto px-4 py-4 text-center">
          <p className="text-xs text-muted-foreground">
            Powered by{' '}
            <span className="font-medium text-foreground">TalentumIQ</span>
          </p>
        </div>
      </footer>
    </div>
  );
}
